export const ISO_STRING_FOR_INDEFINITE_UNAVAILABILITY_END_DATETIME = '9999-01-01T00:00:00';

export const OUT_OF_STOCK_DESCRIPTION = 'Out of Stock';

export const OTHER_CATEGORY_NAME = 'Other';

export const VENUE_OPEN_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
};

export const VENUE_OPEN_STATUS_MAPPING = {
  [VENUE_OPEN_STATUS.OPEN]: {
    color: 'green',
    message: 'venueStatusOpen',
  },
  [VENUE_OPEN_STATUS.CLOSED]: {
    color: 'red-dark',
    message: 'venueStatusClosed',
  },
};

export const VENUE_OPEN_STATUS_OPTIONS = Object.values(VENUE_OPEN_STATUS);

export const ITEM_AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE_TODAY: 'unavailable_today',
  UNAVAILABLE_INDEFINITELY: 'unavailable_indefinitely',
};

export const ITEM_AVAILABILITY_STATUS_MAPPING = {
  [ITEM_AVAILABILITY_STATUS.AVAILABLE]: {
    color: 'green',
    message: 'itemStatusAvailable',
  },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY]: {
    color: 'yellow',
    message: 'itemStatusUnavailableToday',
  },
  [ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY]: {
    color: null,
    message: 'itemStatusUnavailableIndefinitely',
  },
};

export const ITEM_AVAILABILITY_STATUS_OPTIONS = Object.values(ITEM_AVAILABILITY_STATUS);

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const DEFAULT_DAY_AVAILABILITY = {
  times: [{ startTime: '09:00', endTime: '18:00' }],
  available: true,
};

export const DEFAULT_AVAILABILITY = [
  { weekday: 'Sunday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Monday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Tuesday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Wednesday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Thursday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Friday', ...DEFAULT_DAY_AVAILABILITY },
  { weekday: 'Saturday', ...DEFAULT_DAY_AVAILABILITY },
];

export const SHORT_TO_FULL_DAY_MAP = {
  Su: 'Sunday',
  Mo: 'Monday',
  Tu: 'Tuesday',
  We: 'Wednesday',
  Th: 'Thursday',
  Fr: 'Friday',
  Sa: 'Saturday',
};

export const FULL_TO_SHORT_DAY_MAP = Object.fromEntries(
  Object.entries(SHORT_TO_FULL_DAY_MAP).map(([short, full]) => [full, short])
);

export const DEFAULT_DURATION = 5;
export const FOOD_AND_BEVERAGE_TAG_NAME = 'foodAndDrink';
export const NAME_MAX_INPUT_LENGTH = 70;
export const DESCRIPTION_MAX_INPUT_LENGTH = 1000;
export const DESCRIPTION_INPUT_HEIGHT_IN_LINES = 3;

export const ADD_ITEM_FLYOUT_ID_PREFIX = 'add-item-flyout';
export const EDIT_ITEM_FLYOUT_ID_PREFIX = 'edit-item-flyout';

export const getItemsCollapseKey = venueId => `items-collapse-${venueId}`;
